import initAds from './src/init-ads';

export default initAds;
